/* Tear Stones system layer: image fade-in, scroll reveal and menu image warm-up. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const IMAGES = '.ts-home-hero img, .ts-product-card img, .ts-showcase-media img, .product-gallery img, .columns .image-block-media img, .header-megamenu img, .ts-photo-review img, .ts-home-shapes-image img';
  const REVEAL = [
    'main .ts-home-shapes-heading',
    'main .ts-showcase-item',
    'main .ts-home-featured-tabs-nav',
    'main .ts-home-featured-item',
    'main .columns-container > .group-block',
    'main .columns-grid > .group-block',
    'main .ts-photo-reviews-heading',
    'main .ts-photo-review',
    'main .ts-loose-results-grid > li',
    'main .ts-design-card',
  ].join(',');

  const fade = (img) => {
    if (reduce || img.dataset.tsFade) return;
    img.dataset.tsFade = '1';
    if (img.complete && img.naturalWidth) return;
    img.classList.add('ts-fade');
    const done = () => img.classList.add('is-loaded');
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  };

  let observer = null;
  const reveal = (el) => {
    if (reduce || el.dataset.tsReveal) return;
    el.dataset.tsReveal = '1';
    if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
    const siblings = el.parentElement ? [...el.parentElement.children] : [];
    const index = Math.max(0, siblings.indexOf(el)) % 6;
    el.style.setProperty('--ts-reveal-delay', `${index * 60}ms`);
    el.classList.add('ts-reveal');
    observer.observe(el);
  };

  const scan = (root) => {
    root.querySelectorAll(IMAGES).forEach(fade);
    root.querySelectorAll(REVEAL).forEach(reveal);
  };

  const init = () => {
    if (!reduce && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    if (!observer) return;
    scan(document);

    /* Content loaded later (catalog pages, tabs) gets the same treatment. */
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => { queued = false; scan(document); });
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });

    /* Menu photos load before the menu opens. */
    const warm = () => document.querySelectorAll('.header-megamenu img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    const header = document.querySelector('#header-group');
    if (header) header.addEventListener('pointerenter', warm, { once: true });
    if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 4000 });
    else window.setTimeout(warm, 3000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
